<template>
  <nav class="navbar navbar-expand-lg border-bottom shadow-sm">
    <div class="container">
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navMenu"
        aria-controls="navMenu"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navMenu">
        <ul class="navbar-nav ms-auto gap-1">
          <li class="nav-item"><router-link class="nav-link" to="/">Portafolio</router-link></li>
          <li class="nav-item"><router-link class="nav-link" to="/sobre-mi">Sobre Mí</router-link></li>
          <li class="nav-item"><router-link class="nav-link" to="/proyectos">Proyectos</router-link></li>
          <li class="nav-item"><router-link class="nav-link" to="/contacto">Contacto</router-link></li>
        </ul>
      </div>
    </div>
  </nav>

  <main class="container py-4">
    <router-view/>
  </main>

  <AppFooter />
</template>

<script setup>
import AppFooter from './components/AppFooter.vue';
</script>

<style>
.router-link-active {
  color: var(--bs-primary) !important;
  font-weight: bold;
}

.fade-in-up {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.fade-in-up.visible {
  opacity: 1;
  transform: translateY(0);
}
</style>
